import { makeStyles } from '@material-ui/core';

const MENU_BACKGROUND_DEEP = '#0C1727';
const DANGER = '#E35D4F';
const DANGER_HOVER = '#C84438';
const DANGER_SOFT = 'rgba(227, 93, 79, 0.16)';

const useStyles = makeStyles(theme => ({
  '@keyframes fadeIn': {
    from: { opacity: 0 },
    to: { opacity: 1 },
  },
  text: {
    animationName: '$fadeIn',
    animationDuration: '300',
    '& span': {
      [theme.breakpoints.down('sm')]: {
        fontSize: '1.125rem !important',
      },
    },
  },
  errorText: {
    animationName: '$fadeIn',
    animationDuration: '800',
  },
  errorButton: {
    width: '100%',
    // @ts-ignore
    color: '#FFFFFF',
    background: DANGER,
    border: `1px solid ${DANGER}`,
    boxShadow: 'none',
    '&:hover': {
      background: DANGER_HOVER,
      borderColor: DANGER_HOVER,
    },
    minWidth: '38px',
    textWrap: 'wrap',
  },
  popover: {
    padding: theme.spacing(2),
    gap: theme.spacing(2),
    display: 'grid',
    // @ts-ignore
    backgroundColor: MENU_BACKGROUND_DEEP,
    border: `1px solid ${DANGER_SOFT}`,

    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}));

export default useStyles;
